export default {
    buttons: {
        back: "Vissza",
        next: "Következő",
        submit: "Beküldés"
    }
}